<template>
<svg class="home-background" :class="{'near-bottom': nearBottom}" :viewBox="`0 0 ${WIDTH} ${HEIGHT}`">
  <g class="shapes">
    <g class="shape shape-1 cone">
      <circle cx="72" cy="15"/>
      <circle cx="17" cy="54"/>
      <circle cx="42" cy="38"/>
      <circle cx="59.7308" cy="42.7308"/>
      <circle cx="40.7308" cy="18.7308"/>
      <circle cx="47" cy="63"/>
      <circle cx="16" cy="23"/>
      <path d="M19.5345 22.2064L72.3552 13.6934L48.2835 62.3776"/>
      <path class="-dash" d="M47.8436 62.3838C47.4139 63.2274 46.8854 63.9945 46.2562 64.6718L45.8898 64.3315C45.5908 64.6534 45.2678 64.9538 44.9206 65.2313C44.5734 65.5087 44.2091 65.7574 43.8291 65.978L44.0802 66.4104C43.2807 66.8746 42.4159 67.2208 41.4983 67.4537L41.3753 66.9691C40.5386 67.1814 39.6518 67.2961 38.7242 67.3153L38.7345 67.8152C37.8362 67.8337 36.9054 67.7657 35.951 67.6145L36.0293 67.1207C35.1658 66.9839 34.28 66.7767 33.3786 66.501L33.2324 66.9791C32.3689 66.715 31.4939 66.3901 30.613 66.0066L30.8126 65.5482C29.9972 65.1932 29.1756 64.7865 28.3528 64.3299L28.1102 64.7671C27.3147 64.3255 26.5189 63.8385 25.7273 63.3076L26.0058 62.8923C25.259 62.3915 24.5153 61.8506 23.7786 61.2712L23.4695 61.6642C22.7502 61.0984 22.0378 60.4966 21.3357 59.86L21.6715 59.4896C21.0001 58.8809 20.3381 58.2398 19.6884 57.5675L19.3288 57.915C18.6902 57.2542 18.0636 56.5637 17.4517 55.8446L17.8325 55.5206C17.5359 55.172 17.2427 54.8165 16.9534 54.4544C16.664 54.0923 16.382 53.7279 16.1075 53.3616L15.7074 53.6615C15.1411 52.906 14.606 52.1425 14.1024 51.3738L14.5206 51.0998C14.0083 50.3177 13.5291 49.5305 13.0836 48.7413L12.6482 48.9871C12.1823 48.1619 11.7525 47.3342 11.3595 46.5077L11.811 46.293C11.4084 45.4466 11.0451 44.6019 10.7214 43.7629L10.2549 43.9429C9.91178 43.0536 9.61237 42.1701 9.35729 41.2967L9.83724 41.1565C9.57344 40.2532 9.35814 39.3622 9.19185 38.4885L8.70067 38.582C8.52104 37.6383 8.39726 36.713 8.33022 35.8126L8.82884 35.7755C8.75884 34.8355 8.75228 33.9258 8.80945 33.0535L8.31052 33.0208C8.37372 32.0566 8.51281 31.1337 8.72912 30.2617L9.21442 30.3821C9.43779 29.4815 9.74541 28.6419 10.1372 27.8727L9.69162 27.6458C10.1213 26.8022 10.6498 26.0351 11.279 25.3578L11.6453 25.6981C11.9444 25.3762 12.2674 25.0758 12.6146 24.7983C12.9618 24.5209 13.3261 24.2722 13.706 24.0516L13.455 23.6192C14.2545 23.155 15.1193 22.8088 16.0369 22.5759L16.1599 23.0605C16.9965 22.8482 17.8834 22.7335 18.811 22.7143L18.8007 22.2144C19.699 22.1959 20.6298 22.2639 21.5841 22.4151L21.5059 22.9089C22.3693 23.0457 23.2552 23.2529 24.1565 23.5286L24.3028 23.0505C25.1662 23.3146 26.0413 23.6395 26.9221 24.023L26.7226 24.4814C27.538 24.8364 28.3596 25.2431 29.1823 25.6997L29.425 25.2625C30.2205 25.7041 31.0162 26.1911 31.8078 26.722L31.5293 27.1373C32.2762 27.6381 33.0199 28.179 33.7566 28.7584L34.0657 28.3654C34.785 28.9312 35.4974 29.533 36.1995 30.1696L35.8637 30.54C36.535 31.1487 37.1971 31.7898 37.8468 32.4621L38.2064 32.1146C38.845 32.7754 39.4716 33.4659 40.0835 34.185L39.7027 34.509C39.9993 34.8576 40.2925 35.2131 40.5818 35.5752C40.8712 35.9373 41.1531 36.3017 41.4277 36.668L41.8278 36.3681C42.3941 37.1236 42.9292 37.8871 43.4328 38.6558L43.0146 38.9298C43.5269 39.7119 44.006 40.4991 44.4516 41.2883L44.887 41.0425C45.3529 41.8677 45.7826 42.6954 46.1757 43.5219L45.7242 43.7366C46.1268 44.583 46.4901 45.4277 46.8138 46.2667L47.2803 46.0867C47.6234 46.976 47.9228 47.8595 48.1779 48.7329L47.6979 48.8731C47.9617 49.7764 48.177 50.6674 48.3433 51.5411L48.8345 51.4476C49.0141 52.3913 49.1379 53.3165 49.205 54.217L48.7063 54.2541C48.7763 55.1941 48.7829 56.1038 48.7257 56.9761L49.2247 57.0088C49.1615 57.973 49.0224 58.8959 48.8061 59.7679L48.3208 59.6475C48.0974 60.5481 47.7898 61.3877 47.398 62.1569L47.8436 62.3838Z"/>
      <line class="-dash" x1="72.5725" y1="14.3839" x2="17.0647" y2="54.6448"/>
    </g>
    <g class="shape shape-2 sphere">
      <circle cx="54.7308" cy="51.7308"/>
      <circle cx="17" cy="53"/>
      <circle cx="54" cy="51"/>
      <circle cx="52" cy="20"/>
      <circle cx="17" cy="20"/>
      <circle class="circle-line" r="24" cx="35.2116" cy="35.2117"/>
      <path class="-dash" d="M47.4466 18.57C48.6877 18.0592 49.7529 17.795 50.5894 17.8089L50.5811 18.3089C51.1375 18.3181 51.4999 18.4665 51.7276 18.6942C51.9553 18.9219 52.1037 19.2843 52.1129 19.8407L52.6129 19.8324C52.6268 20.6689 52.3625 21.7341 51.8518 22.9752L51.3894 22.7849C51.0357 23.6445 50.5571 24.5985 49.9621 25.6287L50.3951 25.8788C49.8919 26.7501 49.3095 27.6704 48.6545 28.6285L48.2417 28.3464C47.6664 29.188 47.0338 30.0602 46.3484 30.9552L46.7454 31.2592C46.1104 32.0884 45.431 32.9363 44.7109 33.7967L44.3275 33.4758C43.6547 34.2797 42.9459 35.0949 42.2041 35.9165L42.5752 36.2515C41.8644 37.0388 41.1235 37.8317 40.3553 38.6258L39.9959 38.2781C39.6237 38.6629 39.245 39.0479 38.8602 39.4328C38.4753 39.8176 38.0903 40.1963 37.7055 40.5685L38.0532 40.9279C37.2591 41.6961 36.4662 42.4369 35.6789 43.1478L35.3439 42.7767C34.5223 43.5185 33.7071 44.2273 32.9032 44.9001L33.2241 45.2835C32.3637 46.0036 31.5158 46.683 30.6866 47.318L30.3826 46.921C29.4876 47.6064 28.6155 48.239 27.7738 48.8143L28.0559 49.2271C27.0978 49.8821 26.1775 50.4645 25.3062 50.9677L25.0561 50.5347C24.0259 51.1297 23.0719 51.6083 22.2123 51.962L22.4026 52.4244C21.1615 52.9351 20.0963 53.1994 19.2598 53.1854L19.2681 52.6855C18.7117 52.6763 18.3493 52.5279 18.1216 52.3002C17.8939 52.0725 17.7455 51.7101 17.7363 51.1537L17.2363 51.162C17.2224 50.3255 17.4867 49.2603 17.9974 48.0192L18.4598 48.2095C18.8135 47.3499 19.2921 46.3959 19.8871 45.3657L19.4541 45.1156C19.9573 44.2443 20.5397 43.324 21.1947 42.3659L21.6075 42.648C22.1828 41.8063 22.8154 40.9341 23.5008 40.0392L23.1038 39.7352C23.7388 38.906 24.4182 38.0581 25.1383 37.1977L25.5217 37.5186C26.1945 36.7147 26.9033 35.8995 27.6451 35.0779L27.274 34.7429C27.9848 33.9555 28.7257 33.1627 29.4939 32.3686L29.8533 32.7163C30.2255 32.3315 30.6042 31.9465 30.989 31.5616C31.3739 31.1767 31.7589 30.7981 32.1437 30.4259L31.796 30.0665C32.5901 29.2983 33.383 28.5574 34.1703 27.8466L34.5053 28.2177C35.3269 27.4759 36.1421 26.7671 36.946 26.0943L36.6251 25.7109C37.4855 24.9908 38.3334 24.3114 39.1626 23.6764L39.4666 24.0734C40.3615 23.388 41.2337 22.7554 42.0754 22.18L41.7933 21.7673C42.7514 21.1123 43.6717 20.5299 44.543 20.0267L44.7931 20.4597C45.8233 19.8647 46.7773 19.3861 47.6369 19.0324L47.4466 18.57Z"/>
    </g>
    <g class="shape shape-3 cube">
      <circle cx="59" cy="43"/>
      <circle cx="37" cy="36"/>
      <circle cx="41.7308" cy="59.7308"/>
      <circle cx="36.7308" cy="36.7308"/>
      <circle cx="30.7308" cy="10.7308"/>
      <circle cx="55.7308" cy="19.7308"/>
      <circle cx="55.3625" cy="42.8996"/>
      <circle cx="16" cy="54"/>
      <circle cx="12" cy="29"/>
      <circle cx="61" cy="43"/>
      <path class="-dash" d="M35.6068 36.0835L60.1661 43.5025"/>
      <path d="M35.938 35.8917C36.3143 35.3218 49.0796 24.0435 55.4152 18.4756M35.938 35.8917L11.2764 26.7686M35.938 35.8917L40.6384 60.0656M55.4152 18.4756L31.0842 9.16164L11.2764 26.7686M55.4152 18.4756L60.4974 43.3106L40.6384 60.0656M11.2764 26.7686C12.7501 35.1742 15.7356 52.0515 15.8883 52.316C16.0409 52.5805 32.452 57.5926 40.6384 60.0656"/>
      <path class="-dash" d="M36.2678 35.7009L15.8875 52.3161"/>
      <path class="-dash" d="M35.9366 35.892C35.8957 35.2103 32.6836 17.7879 31.0828 9.16194"/>
    </g>
    <g class="shape shape-4 cone">
      <circle cx="39" cy="34"/>
      <circle cx="37" cy="52"/>
      <circle cx="2" cy="38"/>
      <circle cx="25.4135" cy="22.4134"/>
      <circle cx="46.8268" cy="7.82681"/>
      <circle cx="69.8268" cy="30.8268"/>
      <circle cx="53.8268" cy="57.8268"/>
      <path d="M52.0008 57.3639L2.00017 38.326L47.189 8.20009"/>
      <path class="-dash" d="M47.5731 8.4146C48.367 7.89885 49.2082 7.49878 50.0918 7.22682L50.2389 7.7047C50.6588 7.57544 51.0887 7.47677 51.5281 7.41012C51.9676 7.34347 52.4074 7.31022 52.8468 7.30913L52.8455 6.80913C53.77 6.80684 54.6921 6.93945 55.6032 7.19657L55.4674 7.67778C56.2981 7.91221 57.1235 8.25628 57.9364 8.70353L58.1774 8.26546C58.9646 8.69857 59.7367 9.22285 60.4876 9.83094L60.173 10.2195C60.8523 10.7696 61.5159 11.392 62.1587 12.0815L62.5244 11.7405C63.1401 12.401 63.7355 13.1199 64.3065 13.8924L63.9045 14.1896C64.4332 14.9048 64.9413 15.6677 65.4256 16.4746L65.8543 16.2173C66.3225 16.9975 66.7681 17.8171 67.1882 18.6727L66.7394 18.8931C67.1357 19.7003 67.5093 20.5405 67.8576 21.4106L68.3218 21.2248C68.6619 22.0745 68.9779 22.9519 69.2677 23.8542L68.7916 24.0071C69.0687 24.8699 69.3215 25.7561 69.548 26.6632L70.0331 26.5421C70.2558 27.4337 70.4532 28.345 70.6236 29.2736L70.1318 29.3638C70.2144 29.8141 70.2906 30.2685 70.3601 30.7268C70.4296 31.185 70.4916 31.6416 70.5462 32.0961L71.0426 32.0364C71.1553 32.9738 71.237 33.9026 71.2888 34.8201L70.7896 34.8483C70.8422 35.7818 70.8636 36.7031 70.8548 37.6093L71.3548 37.6141C71.3457 38.5618 71.304 39.4934 71.2312 40.4057L70.7328 40.3659C70.6582 41.3002 70.5506 42.2134 70.4114 43.1019L70.9054 43.1792C70.7579 44.1209 70.5754 45.0358 70.3596 45.9197L69.8739 45.8011C69.6507 46.7153 69.3916 47.5946 69.0988 48.4344L69.5709 48.599C69.2546 49.5061 68.8992 50.3693 68.507 51.1826L68.0567 50.9654C67.6473 51.8145 67.1981 52.6056 66.7124 53.3325L67.1282 53.6103C66.5913 54.4137 66.0095 55.1433 65.3861 55.7904L65.026 55.4435C64.3823 56.1117 63.6961 56.685 62.9722 57.1553L63.2446 57.5746C62.4507 58.0903 61.6095 58.4904 60.7259 58.7623L60.5788 58.2845C60.1588 58.4137 59.7289 58.5124 59.2895 58.579C58.8501 58.6457 58.4103 58.6789 57.9709 58.68L57.9721 59.18C57.0477 59.1823 56.1256 59.0497 55.2145 58.7926L55.3503 58.3114C54.5196 58.077 53.6942 57.7329 52.8813 57.2856L52.6402 57.7237C51.853 57.2906 51.081 56.7663 50.33 56.1582L50.6447 55.7696C49.9653 55.2195 49.3018 54.5972 48.659 53.9077L48.2933 54.2486C47.6776 53.5882 47.0822 52.8693 46.5111 52.0968L46.9132 51.7995C46.3845 51.0844 45.8763 50.3214 45.3921 49.5146L44.9634 49.7719C44.4952 48.9917 44.0496 48.1721 43.6295 47.3165L44.0783 47.0961C43.682 46.2889 43.3083 45.4487 42.9601 44.5785L42.4959 44.7643C42.1558 43.9147 41.8397 43.0373 41.55 42.135L42.0261 41.9821C41.749 41.1192 41.4962 40.233 41.2696 39.3259L40.7845 39.4471C40.5619 38.5555 40.3645 37.6442 40.1941 36.7155L40.6859 36.6253C40.6033 36.1751 40.5271 35.7207 40.4576 35.2624C40.3881 34.8041 40.3261 34.3476 40.2715 33.8931L39.775 33.9528C39.6624 33.0154 39.5807 32.0865 39.5289 31.169L40.0281 31.1408C39.9754 30.2074 39.9541 29.2861 39.9628 28.3798L39.4629 28.375C39.472 27.4274 39.5137 26.4957 39.5865 25.5834L40.0849 25.6232C40.1595 24.6889 40.2671 23.7757 40.4063 22.8873L39.9123 22.8099C40.0598 21.8683 40.2423 20.9534 40.4581 20.0694L40.9438 20.188C41.167 19.2739 41.4261 18.3945 41.7189 17.5548L41.2468 17.3901C41.5631 16.483 41.9185 15.6199 42.3107 14.8066L42.761 15.0237C43.1704 14.1747 43.6196 13.3835 44.1053 12.6567L43.6895 12.3789C44.2264 11.5755 44.8082 10.8458 45.4316 10.1988L45.7917 10.5457C46.4354 9.87748 47.1216 9.30412 47.8454 8.8339L47.5731 8.4146Z"/>
      <line class="-dash" x1="2.15724" y1="37.6193" x2="70.3589" y2="30.5063"/>
    </g>
    <g class="shape shape-5 sphere">
      <circle cx="55" cy="36"/>
      <circle cx="33" cy="25"/>
      <circle cx="30.5" cy="36.5"/>
      <circle cx="23" cy="53"/>
      <circle cx="8" cy="23"/>
      <circle cx="8.82678" cy="23.8268"/>
      <circle cx="39.8268" cy="8.82681"/>
      <circle class="circle-line" r="24" cx="30.9088" cy="30.2114"/>
      <path class="-dash" d="M51.4384 32.4865C52.5013 33.306 53.2627 34.0963 53.6689 34.8277L53.2317 35.0705C53.5019 35.557 53.5547 35.945 53.4713 36.2561C53.388 36.5671 53.1483 36.8768 52.6711 37.163L52.9282 37.5918C52.2108 38.0221 51.1562 38.3259 49.826 38.5041L49.7596 38.0086C48.8383 38.132 47.7728 38.1945 46.5831 38.1944L46.5831 38.6944C45.5768 38.6943 44.4886 38.65 43.3314 38.5619L43.3694 38.0633C42.3528 37.9859 41.2811 37.8741 40.1634 37.7281L40.0986 38.2238C39.063 38.0885 37.989 37.9241 36.8838 37.7307L36.97 37.2382C35.9374 37.0575 34.8771 36.8513 33.7947 36.6196L33.69 37.1086C32.6528 36.8866 31.5957 36.6414 30.5239 36.3732L30.6453 35.8881C30.126 35.7581 29.6032 35.6227 29.0775 35.4819C28.5517 35.341 28.0313 35.1969 27.5166 35.0498L27.3792 35.5305C26.3168 35.2269 25.2788 34.9107 24.2695 34.5843L24.4234 34.1086C23.3702 33.768 22.3487 33.4164 21.3642 33.0566L21.1925 33.5262C20.1387 33.1411 19.1264 32.7465 18.1619 32.3459L18.3537 31.8842C17.3127 31.4518 16.3287 31.0127 15.4096 30.5715L15.1932 31.0223C14.1469 30.52 13.1824 30.0142 12.3109 29.5112L12.5609 29.0781C11.5305 28.4834 10.639 27.8965 9.90287 27.329L9.59758 27.725C8.53472 26.9055 7.7733 26.1151 7.36712 25.3838L7.80423 25.141C7.53404 24.6545 7.48129 24.2665 7.56464 23.9554C7.64798 23.6444 7.88768 23.3347 8.36493 23.0485L8.10776 22.6197C8.82521 22.1894 9.8798 21.8856 11.21 21.7074L11.2764 22.2029C12.1977 22.0795 13.2632 22.017 14.4529 22.0171L14.4529 21.5171C15.4592 21.5172 16.5474 21.5615 17.7046 21.6496L17.6666 22.1482C18.6832 22.2256 19.7549 22.3374 20.8726 22.4834L20.9374 21.9876C21.973 22.123 23.047 22.2874 24.1522 22.4808L24.066 22.9733C25.0985 23.154 26.1589 23.3602 27.2413 23.5919L27.346 23.1029C28.3832 23.3249 29.4403 23.5701 30.5121 23.8383L30.3907 24.3234C30.91 24.4533 31.4328 24.5888 31.9585 24.7296C32.4842 24.8705 33.0047 25.0146 33.5194 25.1617L33.6568 24.681C34.7191 24.9845 35.7572 25.3008 36.7665 25.6271L36.6126 26.1029C37.6658 26.4435 38.6872 26.7951 39.6718 27.1549L39.8434 26.6853C40.8973 27.0704 41.9095 27.4649 42.8741 27.8656L42.6823 28.3273C43.7233 28.7597 44.7073 29.1987 45.6264 29.64L45.8428 29.1892C46.8891 29.6915 47.8536 30.1973 48.7251 30.7003L48.4751 31.1333C49.5055 31.7281 50.397 32.3149 51.1331 32.8825L51.4384 32.4865Z"/>
    </g>
    <g class="shape shape-6 cube">
      <circle cx="14" cy="46"/>
      <circle cx="30.2811" cy="30.1766"/>
      <circle cx="47" cy="16"/>
      <circle cx="52" cy="37"/>
      <circle cx="33.8268" cy="50.8268"/>
      <circle cx="30.8268" cy="30.8268"/>
      <circle cx="8.82678" cy="23.8268"/>
      <circle cx="26.8268" cy="7.82681"/>
      <path class="-dash" d="M30.1316 30.5723L50.8057 36.8176"/>
      <path d="M30.4105 30.4107C30.7272 29.931 41.4731 20.4369 46.8065 15.7498M30.4105 30.4107L9.65027 22.7309M30.4105 30.4107L34.3673 50.7604M46.8065 15.7498L26.3245 7.90929L9.65027 22.7309M46.8065 15.7498L51.0846 36.6561L34.3673 50.7604M9.65027 22.7309C10.8908 29.8068 13.404 44.0142 13.5325 44.2368C13.6611 44.4594 27.4759 48.6786 34.3673 50.7604"/>
      <path class="-dash" d="M30.6888 30.2503L13.5325 44.2371"/>
      <path class="-dash" d="M30.4098 30.411C30.3754 29.8372 27.6715 15.1709 26.3238 7.90954"/>
    </g>
    <g class="shape shape-7 sphere">
      <circle cx="41.4134" cy="40.4134"/>
      <circle cx="13.8268" cy="40.8268"/>
      <circle cx="45" cy="17"/>
      <circle cx="16" cy="12"/>
      <circle class="circle-line" r="19" cx="27.5771" cy="27.5772"/>
      <path class="-dash" d="M42.8736 36.5639C42.8777 37.6089 42.6934 38.5433 42.3072 39.3297L41.8584 39.1092C41.6693 39.4943 41.4276 39.8362 41.1318 40.132C40.836 40.4278 40.4942 40.6694 40.109 40.8586L40.3295 41.3074C39.5431 41.6936 38.6087 41.8779 37.5637 41.8738L37.5656 41.3738C36.7456 41.3707 35.8419 41.2445 34.8734 40.9969L34.7496 41.4813C33.8886 41.2612 32.9869 40.9506 32.0582 40.5544L32.2544 40.0945C31.4405 39.7473 30.6031 39.3319 29.7521 38.8514L29.5063 39.2868C28.7096 38.837 27.9029 38.3321 27.0939 37.7749L27.3775 37.3631C26.6282 36.847 25.8762 36.285 25.128 35.6793L24.8134 36.0679C24.0914 35.4835 23.3734 34.8593 22.6648 34.1974L23.0061 33.832C22.6661 33.5143 22.3282 33.1878 21.9931 32.8527C21.6579 32.5176 21.3314 32.1797 21.0138 31.8396L20.6484 32.181C19.9865 31.4724 19.3623 30.7544 18.7779 30.0324L19.1665 29.7178C18.5608 28.9696 17.9987 28.2176 17.4827 27.4683L17.0709 27.7519C16.5137 26.9429 16.0088 26.1362 15.559 25.3395L15.9944 25.0937C15.5139 24.2426 15.0985 23.4053 14.7513 22.5914L14.2914 22.7876C13.8952 21.8589 13.5845 20.9572 13.3644 20.0962L13.8489 19.9724C13.6013 19.0039 13.4751 18.1002 13.472 17.2802L12.972 17.2821C12.9679 16.2371 13.1522 15.3027 13.5384 14.5163L13.9872 14.7367C14.1763 14.3516 14.418 14.0098 14.7138 13.714C15.0096 13.4182 15.3515 13.1765 15.7366 12.9874L15.5161 12.5386C16.3025 12.1523 17.2369 11.9681 18.2819 11.9721L18.28 12.4721C19.1 12.4753 20.0037 12.6015 20.9722 12.849L21.096 12.3646C21.957 12.5847 22.8587 12.8954 23.7874 13.2916L23.5912 13.7515C24.4051 14.0987 25.2425 14.5141 26.0935 14.9946L26.3393 14.5592C27.136 15.009 27.9427 15.5139 28.7517 16.0711L28.4681 16.4828C29.2174 16.9989 29.9694 17.5609 30.7176 18.1667L31.0322 17.778C31.7542 18.3625 32.4722 18.9866 33.1808 19.6486L32.8395 20.014C33.1795 20.3316 33.5174 20.6581 33.8525 20.9932C34.1877 21.3284 34.5142 21.6663 34.8318 22.0063L35.1972 21.665C35.8591 22.3736 36.4833 23.0916 37.0677 23.8135L36.6791 24.1281C37.2848 24.8764 37.8469 25.6284 38.3629 26.3777L38.7747 26.0941C39.3319 26.9031 39.8368 27.7098 40.2866 28.5064L39.8512 28.7523C40.3317 29.6033 40.7471 30.4407 41.0943 31.2546L41.5542 31.0584C41.9504 31.9871 42.2611 32.8888 42.4812 33.7498L41.9967 33.8736C42.2443 34.8421 42.3705 35.7458 42.3736 36.5658L42.8736 36.5639Z"/>
    </g>
  </g>
  <g class="free-dots">
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
    <circle/>
  </g>
</svg>
</template>

<script>
import { gsap } from "gsap";

const SELECTORS = {
  SHAPES: 'g.shapes',
  SHAPE_DOTS: 'g.shape > circle:not(.circle-line)',
  FREE_DOTS_GROUP: 'g.free-dots',
  FREE_DOTS: 'g.free-dots > circle',
  ALL_DASH: 'g.shape > .-dash',
  ALL_LINE: 'g.shape > line:not(.-dash), g.shape > path:not(.-dash), g.shape > .circle-line:not(.-dash)',
  ALL_SHAPES: 'g.shape',
};

const DURATIONS_IN_SECONDS = {
  INITIAL_FLAOTING: 2,
  MOVE_IN: 1,
  DRAW_LINE: 1,
};

const TIMELINE_LABLES = {
  INIT: 'INIT',
  MOVE_IN_START: 'MOVE_IN_START',
  DRAW_LINE_START: 'DRAW_LINE_START',
};

const NEAR_BOTTOM_THRESHOLD = 300;

export default {
  data() {
    return {
      WIDTH: window.innerWidth,
      HEIGHT: window.innerHeight,
      runningFloating: [],  // This need to be killed when switching states
      state: 'separate',  // separate, connected, shapes-only
      nearBottom: false,
    };
  },
  created() {
    window.addEventListener('scroll', this._scrollHandler.bind(this));
  },
  destroyed() {
    window.removeEventListener('scroll', this._scrollHandler.bind(this));
  },
  mounted() {
    this._initAnimation();
  },
  methods: {
    _initAnimation() {
      let floatShapeDots, floatFreeDots;

      gsap.timeline()
        .to(SELECTORS.FREE_DOTS_GROUP, {duration: 100, rotation: 360, repeat: -1, ease: 'none', svgOrigin: `${this.WIDTH /2} ${this.HEIGHT / 2}`}, 0)
        .to(SELECTORS.SHAPES, {duration: 200, rotation: -360, repeat: -1, ease: 'none', svgOrigin: `${this.WIDTH /2} ${this.HEIGHT / 2}`}, 0)
        .set([SELECTORS.ALL_DASH, SELECTORS.ALL_LINE], {strokeDasharray: '0 100'}, 0)
        .add(this._setShapePosition(false, true), 0)
        .add(this._randomizeDotsPosition(false), 0)
        .call(() => {
          floatShapeDots = groupFloating(SELECTORS.SHAPE_DOTS, 50);
          floatFreeDots = groupFloating(SELECTORS.FREE_DOTS, 50);
          this.runningFloating = [floatShapeDots, floatFreeDots];
        }, null, 0)
        .add(floatShapeDots, 0)
        .add(floatFreeDots, 0)
    },
    _connectDots() {
      this._stopAllFloating();

      let floatFreeDots;
      gsap.timeline()
        .call(() => {
          floatFreeDots = groupFloating(SELECTORS.FREE_DOTS, 50);
          this.runningFloating = [floatFreeDots];
        }, null, 0)
        .add(floatFreeDots, 0)
        .add(this._setShapePosition(true), 0)
        .to(SELECTORS.SHAPE_DOTS, {
          duration: DURATIONS_IN_SECONDS.MOVE_IN,
          r: 2,
          x: 0,
          y: 0,
        }, 0)
        .addLabel(TIMELINE_LABLES.DRAW_LINE_START, '-=.5')
          .to(SELECTORS.ALL_LINE, {duration: DURATIONS_IN_SECONDS.DRAW_LINE, strokeDasharray: '1 0'}, TIMELINE_LABLES.DRAW_LINE_START)
          .to(SELECTORS.ALL_DASH, {duration: DURATIONS_IN_SECONDS.DRAW_LINE, strokeDasharray: '3 3'}, TIMELINE_LABLES.DRAW_LINE_START)
          .to(SELECTORS.ALL_SHAPES, {duration: 'random(20, 30)', rotation: 360, repeat: -1, ease: 'none', transformOrigin: '50% 50%'}, TIMELINE_LABLES.DRAW_LINE_START)
          .to(SELECTORS.ALL_DASH, {duration: 1, strokeDashoffset: 25, repeat: -1, ease: 'none'}, TIMELINE_LABLES.DRAW_LINE_START)
    },
    _reverseConnectDots() {
      this._stopAllFloating();

      let floatShapeDots, floatFreeDots;
      gsap.timeline()
        .to([SELECTORS.ALL_DASH, SELECTORS.ALL_LINE], {duration: DURATIONS_IN_SECONDS.DRAW_LINE, strokeDasharray: '0 10', ease: 'none'}, 0)
        .add(this._setShapePosition(true, true), 0)
        .add(this._randomizeDotsPosition(true), 0)
        .call(() => {
          floatShapeDots = groupFloating(SELECTORS.SHAPE_DOTS, 50);
          floatFreeDots = groupFloating(SELECTORS.FREE_DOTS, 50);
          this.runningFloating = [floatShapeDots, floatFreeDots];
        }, null, 0)
        .add(groupFloating(SELECTORS.SHAPE_DOTS, 50), 0)
        .add(groupFloating(SELECTORS.FREE_DOTS, 50), 0)
    },
    _simplify() {
      gsap.to(SELECTORS.FREE_DOTS, {duration: 1, opacity: 0});
      gsap.to(SELECTORS.SHAPES, {duration: 1, opacity: .5});
    },
    _reverseSimplify() {
      gsap.to(SELECTORS.FREE_DOTS, {duration: 1, opacity: 1});
      gsap.to(SELECTORS.SHAPES, {duration: 1, opacity: 1});
    },
    _randomizeDotsPosition(isAnimating) {
      if (isAnimating) {
        return gsap.timeline()
          .to(SELECTORS.SHAPE_DOTS, {
            duration: DURATIONS_IN_SECONDS.MOVE_IN,
            r: 'random(1, 3)',
            x: `random(-${this.WIDTH / 15}, ${this.WIDTH / 15})`,
            y: `random(-${this.HEIGHT / 15}, ${this.HEIGHT / 15})`,
          })
          .to(SELECTORS.FREE_DOTS, {
            duration: DURATIONS_IN_SECONDS.MOVE_IN,
            r: 'random(1, 3)',
            x: `random(${this.WIDTH * .2}, ${this.WIDTH * .8})`,
            y: `random(${this.HEIGHT * .2}, ${this.HEIGHT * .8})`,
          });
      } else {
        return gsap.timeline()
          .set(SELECTORS.SHAPE_DOTS, {
            r: 'random(1, 3)',
            x: `random(-${this.WIDTH / 15}, ${this.WIDTH / 15})`,
            y: `random(-${this.HEIGHT / 15}, ${this.HEIGHT / 15})`,
          })
          .set(SELECTORS.FREE_DOTS, {
            r: 'random(1, 3)',
            x: `random(${this.WIDTH * .2}, ${this.WIDTH * .8})`,
            y: `random(${this.HEIGHT * .2}, ${this.HEIGHT * .8})`,
          });
      }
    },
    _setShapePosition(isAnimating, isHalfPosition=false) {
      const timeline = gsap.timeline();
      SHAPE_FINAL_POSITION.forEach((shape, index) => {
        if (isAnimating) {
          timeline
            .to(`.shape-${index + 1}`, {
              duration: DURATIONS_IN_SECONDS.MOVE_IN,
              x: (isHalfPosition ? (shape.x + .5) / 2 : shape.x) * this.WIDTH,
              y: (isHalfPosition ? (shape.y + .5) / 2 : shape.y) * this.HEIGHT,
            }, 0);
        } else {
          timeline
            .set(`.shape-${index + 1}`, {
              x: (isHalfPosition ? (shape.x + .5) / 2 : shape.x) * this.WIDTH,
              y: (isHalfPosition ? (shape.y + .5) / 2 : shape.y) * this.HEIGHT,
            }, 0);
        }
      });
      return timeline;
    },
    _stopAllFloating() {
      this.runningFloating.forEach((tl) => tl.pause());
      this.runningFloating = [];
    },
    _scrollHandler() {
      switch(this.state) {
        case 'separate':
          if (window.scrollY > window.innerHeight * .7) {
            this._connectDots();
            this.state = 'connected';
          }
          break;
        case 'connected':
          if (window.scrollY < window.innerHeight * .7) {
            this._reverseConnectDots();
            this.state = 'separate';
          }
          if (window.scrollY > window.innerHeight * 1.7) {
            this._simplify();
            this.state = 'shapes-only';
          }
          break;
        case 'shapes-only':
          if (window.scrollY < window.innerHeight * 1.7) {
            this._reverseSimplify();
            this.state = 'connected';
          }
          break;
      }

      this.nearBottom = document.body.scrollHeight - window.innerHeight - window.scrollY < NEAR_BOTTOM_THRESHOLD;
    },
  },
}

const itemFloating = (el, distance, isSlow) => {
  const duration = isSlow ? 'random(4, 5)' : 'random(1, 2)';
  return gsap.timeline({repeat: -1, yoyo: true})
    .to(el, { duration, x: `+=random(-${distance}, ${distance})`, y: `+=random(-${distance}, ${distance})`, ease: 'power1.easeInOut'})
    .to(el, { duration, x: `+=random(-${distance}, ${distance})`, y: `+=random(-${distance}, ${distance})`, ease: 'power1.easeInOut'})
};

const groupFloating = (selector, distance, isSlow) => {
  const elements = typeof selector === 'string' ? document.querySelectorAll(selector) : selector;
  const timeline = gsap.timeline();
  elements.forEach((el) => {
    timeline.add(itemFloating(el, distance, isSlow), 0);
  });
  return timeline;
};

const SHAPE_FINAL_POSITION = [
  {x: 132 / 1440, y: 508 / 800},
  {x: 154 / 1440, y: 162 / 800},
  {x: 1156 / 1440, y: 510 / 800},
  {x: 1157 / 1440, y: 180 / 800},
  {x: 461 / 1440, y: 625 / 800},
  {x: 696 / 1440, y: 109 / 800},
  {x: 927 / 1440, y: 274 / 800},
];
</script>

<style lang="scss" scoped>
svg {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  opacity: 0.6;
  transition: opacity var(--transition);

  &.near-bottom {
    opacity: 0;
  }
}
</style>

<style lang="scss">
.home-background {
  circle {
    fill: white;
  }
  
  path, line, .circle-line {
    stroke: white;
    fill: none;
  }
}
</style>
